module.exports = __webpack_public_path__ + "2ccc8c1a834a5599270c55628a3a6657.jpg";